import React from 'react';
import { Link } from 'react-router-dom';
import './ProjectCards.css';

import tilion from '../Assets/tilion.svg';
import gzoo from '../Assets/gzoo.svg';
import hala from '../Assets/hala.svg';
import museum from '../Assets/museum.svg';
import vignarette from '../Assets/vignarette.svg';
import todou from '../Assets/todou.svg';

const projects = [
  { id: 'tilion', image: tilion, alt: 'Tilion project', href: '/projectdetails/tilion' },
  { id: 'gzoo', image: gzoo, alt: 'GZoo project', href: '/projectdetails' },
  { id: 'hala', image: hala, alt: 'Hala project', href: '/projectdetails' },
  { id: 'museum', image: museum, alt: 'Museum project', href: '/projectdetails' },
  { id: 'vignarette', image: vignarette, alt: 'Vignarette project', href: '/projectdetails' },
  { id: 'todou', image: todou, alt: 'Todou project', href: '/projectdetails' },
];

const ProjectCards = () => {
  return (
    <section className="project-cards" aria-label="Project gallery">
      <ul className="project-cards__grid">
        {projects.map((project) => (
          <li key={project.id} className="project-cards__item">
            <Link to={project.href} className="project-cards__card">
              <img
                src={project.image}
                alt={project.alt}
                className="project-cards__image"
                loading="lazy"
              />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProjectCards;
